module.exports = __webpack_public_path__ + "static/media/explore-more-ways-save-background.95470e6d.webp";